<script setup lang="ts">
import { type CardChallengeLeaderboardPlayer, ChallengeMedal } from '@/types/leaderboard-player'
import { twMerge } from 'tailwind-merge'
import PlayerAvatar from '@/components/PlayerAvatar.vue'
import { formatNumberSemiTruncate } from '@/helpers/utils'
import GoldMedalImage from '@/assets/images/badges/medal-gold.png'
import SilverMedalImage from '@/assets/images/badges/medal-silver.png'
import BronzeMedalImage from '@/assets/images/badges/medal-bronze.png'
import NumberFormatTooltip from '@/components/NumberFormatTooltip.vue'

defineProps<{
  player?: CardChallengeLeaderboardPlayer
  index: string,
  cardClass?: string
  isOwn?: boolean
  medal?: ChallengeMedal
}>()

const medalImageMap = {
  [ChallengeMedal.GOLD]: GoldMedalImage,
  [ChallengeMedal.SILVER]: SilverMedalImage,
  [ChallengeMedal.BRONZE]: BronzeMedalImage,
}
</script>
<template>
  <div
    v-if="player"
    class="rounded-2xl flex  justify-between items-center bg-dark-primary w-full h-full"
  >
    <div
      :class="twMerge('rounded-xl flex justify-between items-center bg-dark-bottom-layer w-full p-2 gap-x-2',
                      isOwn && 'border-2 border-teal-primary',
                      cardClass)"
    >
      <div class="flex gap-x-2 items-center truncate">
        <span class="text-white text-base font-semibold"> {{ `${index}.` }}</span>
        <PlayerAvatar
          class="size-6 min-w-[24px]"
          :image-src="player.photoUrl"
          :first-name="player.firstName"
          :outer-border-style="false"
          custom-class="p-0"
        />
        <p :class="twMerge('font-semibold text-base tracking-tight truncate')">
          {{ player.firstName }}
        </p>
        <img
          v-if="medal"
          :src="medalImageMap[medal]"
          class="size-6 min-w-[24px] object-cover"
        >
      </div>
      <NumberFormatTooltip
        :number="player.score ?? 0"
        :formatting-type="'semi'"
      >
        <p
          :class="'text-white/[60%] text-2xl leading-6 font-medium -tracking-[0.28px]'"
        >
          {{ formatNumberSemiTruncate(player.score) }}
        </p>
      </NumberFormatTooltip>
    </div>
  </div>
</template>
